/* eslint-disable @angular-eslint/prefer-standalone */
import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { PoDynamicViewField, PoModalAction, PoModalComponent, PoTableColumn } from '@po-ui/ng-components';
import { ISalesTaxesResponse } from "../../interfaces/sales-model";
import { LiteralsWords } from "src/app/i18n/literals.model";
import { LiteralsService } from "../../services/literals-service";

@Component({
    selector: 'tgv-details-taxes',
    standalone: false,
    templateUrl: './details-taxes.component.html'
})
export class DetailsTaxesComponent implements OnInit{
    @Input() dataDetailsTaxes: ISalesTaxesResponse;
    @Input() isLoading: boolean = false;
    @ViewChild('detailsTaxesModal', { static: true }) detailsTaxesModal: PoModalComponent;
    modalOptions: PoModalAction[];
    columnsItemsDetailsTaxes = [];
    columnsDetailsTaxes = [];
    fieldsDetailsTaxes = [];
    literals: LiteralsWords;

    constructor(
      private literalsService: LiteralsService
    ){
      this.literals = this.literalsService.getLiteralModule();
    }

    ngOnInit(): void {
        this.onInitSetModalColumnsAndFields();
        this.onInitModalOptions();
    }

    onInitModalOptions(): void {
        this.modalOptions = [
          {
            action: () => this.detailsTaxesModal.close(),
            label: this.literals.str0034
          }
        ];
    }

    onInitSetModalColumnsAndFields(): void {
        this.fieldsDetailsTaxes = this.getFieldsDetailsTaxesModal();
        this.columnsDetailsTaxes = this.getColumnsDetailsTaxes();
        this.columnsItemsDetailsTaxes = this.getColumnsItemsDetailsTaxes();
    }

    getFieldsDetailsTaxesModal(): PoDynamicViewField[] {
        return [
          { property: 'valor_contabil', gridColumns: 6, label: this.literals.str0818, type: 'currency' },
          { property: 'valor_mercadoria', gridColumns: 6, label: this.literals.str0819, type: 'currency' },
          { property: 'total_impostos_embutidos', gridColumns: 6, label: this.literals.str0820, type: 'currency' },
          { property: 'total_impostos_sem_incidencia', gridColumns: 6, label: this.literals.str0821, type: 'currency' },
          { property: 'total_impostos', gridColumns: 6, label: this.literals.str0822, type: 'currency' },
          { property: 'desconto', gridColumns: 6, label: this.literals.str0240, type: 'currency' },
          { property: 'base_duplicada', gridColumns: 6, label: this.literals.str0823, type: 'currency' },
          { property: 'seguro', gridColumns: 6, label: this.literals.str0237, type: 'currency' },
          { property: 'frete', gridColumns: 6, label: this.literals.str0236, type: 'currency' },
          { property: 'despesas_acessorias', gridColumns: 6, label: this.literals.str0824, type: 'currency' }
        ];
      }

    getColumnsDetailsTaxes(): PoTableColumn[] {
        return [
          {
            property: 'imposto',
            width: '10%',
            label: this.literals.str0825,
            visible: true
          },
          {
            property: 'descricao',
            width: '10%',
            label: this.literals.str0047,
            visible: true
          },
          {
            property: 'base_calculo',
            width: '10%',
            label: this.literals.str0826,
            visible: true,
            type: 'currency'
          },
          {
            property: 'aliquota',
            width: '10%',
            label: this.literals.str0827,
            visible: true,
            type: 'number'
          },
          {
            property: 'valor',
            width: '10%',
            label: this.literals.str0177,
            visible: true,
            type: 'currency'
          }
        ];
      }

    getColumnsItemsDetailsTaxes(): PoTableColumn[] {
        return [
          {
            property: 'codigo_produto',
            label: this.literals.str0828,
            visible: true
          },
          {
            property: 'tes',
            label: this.literals.str0844,
            visible: true
          },
          {
            property: 'quantidade',
            label: this.literals.str0244,
            visible: true,
            type: 'number'
          },
          {
            property: 'valor_unitario',
            label: this.literals.str0831,
            visible: true,
            type: 'currency'
          },
          {
            property: 'valor_mercadoria',
            label: this.literals.str0819,
            visible: true,
            type: 'currency'
          },
          {
            property: 'desconto',
            label: this.literals.str0240,
            visible: true,
            type: 'currency'
          },
          {
            property: 'frete',
            label: this.literals.str0236,
            visible: true,
            type: 'currency'
          },
          {
            property: 'seguro',
            label: this.literals.str0237,
            visible: true,
            type: 'currency'
          },
          {
            property: 'despesas_acessorias',
            label: this.literals.str0824,
            visible: true,
            type: 'currency'
          },
          {
            property: 'valor_total',
            label: this.literals.str0303,
            visible: true,
            type: 'currency'
          },
          {
            property: 'aliquota_st',
            label: this.literals.str0840,
            visible: true,
            type: 'number'
          },
          {
            property: 'valor_st',
            label: this.literals.str0829,
            visible: true,
            type: 'currency'
          },
          {
            property: 'aliquota_pis',
            label: this.literals.str0832,
            visible: true,
            type: 'number'
          },
          {
            property: 'valor_pis',
            label: this.literals.str0834,
            visible: true,
            type: 'currency'
          },
          {
            property: 'valor_pis_apur',
            label: this.literals.str0835,
            visible: true,
            type: 'currency'
          },
          {
            property: 'valor_pis_st',
            label: this.literals.str0836,
            visible: true,
            type: 'currency'
          },
          {
            property: 'aliquota_cofins',
            label: this.literals.str0837,
            visible: true,
            type: 'number'
          },
          {
            property: 'valor_cofins',
            label: this.literals.str0838,
            visible: true,
            type: 'currency'
          },
          {
            property: 'valor_cofins_apur',
            label: this.literals.str0839,
            visible: true,
            type: 'currency'
          },
          {
            property: 'aliquota_csll',
            label: this.literals.str0841,
            visible: true,
            type: 'number'
          },
          {
            property: 'valor_csll',
            label: this.literals.str0830,
            visible: true,
            type: 'currency'
          },
          {
            property: 'aliquota_ipi',
            label: this.literals.str0833,
            visible: true,
            type: 'number'
          },
          {
            property: 'valor_ipi',
            label: this.literals.str0843,
            visible: true,
            type: 'currency'
          },
          {
            property: 'valor_icms',
            label: this.literals.str0842,
            visible: true,
            type: 'currency'
          }
        ];
      }
}
